 
let baseUrl = 'https://admin.maochen.vip/'
// let baseUrl = 'http://192.168.1.22:8181/'


 export  {baseUrl}